var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconResumeCopy = function SvgIconResumeCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.999 9.334h-32a2.667 2.667 0 0 0-2.667 2.667v34.666a2.667 2.667 0 0 0 2.667 2.667h32a2.667 2.667 0 0 0 2.666-2.667V12.001A2.667 2.667 0 0 0 52 9.334Z",
    fill: "#FFAD24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.999 14.667h-32a2.667 2.667 0 0 0-2.667 2.667V52a2.667 2.667 0 0 0 2.667 2.667h32A2.667 2.667 0 0 0 46.665 52V17.334A2.667 2.667 0 0 0 44 14.667Z",
    fill: "#FFC82A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.832 41a1.833 1.833 0 0 0 0-3.666H19.165a1.833 1.833 0 0 0 0 3.667h17.667ZM36.832 48a1.833 1.833 0 0 0 0-3.666H19.165a1.833 1.833 0 0 0 0 3.667h17.667Z",
    fill: "#FFDA67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 27.127a2.897 2.897 0 1 0 0-5.793 2.897 2.897 0 0 0 0 5.793ZM32.145 33.333h-8.293c-.826 0-1.45-.79-1.22-1.583.677-2.323 2.823-3.88 5.363-3.88 2.54 0 4.687 1.557 5.364 3.88.23.793-.39 1.583-1.22 1.583h.006Z",
    fill: "#F9F9FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.87 30.703 44.39 35.18a1.833 1.833 0 1 0 2.593 2.593l4.478-4.478a1.833 1.833 0 0 0-2.593-2.593Z",
    fill: "#CA7300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m51.463 30.702-4.478-4.478a1.833 1.833 0 1 0-2.593 2.593l4.478 4.478a1.833 1.833 0 0 0 2.593-2.593Z",
    fill: "#CA7300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.166 30.167h-10a1.833 1.833 0 0 0 0 3.667h10a1.833 1.833 0 0 0 0-3.667Z",
    fill: "#CA7300"
  })));
};
export default SvgIconResumeCopy;